import {
  Component,
  OnInit,
  AfterViewInit,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Output,
} from '@angular/core';
import { UserManagementService } from '../../../services/user-management.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from 'src/app/core/components/alert/alert.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SignUpComponent } from '../../sign-up/sign-up.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
})
export class UsersListComponent implements OnInit, AfterViewInit {
  customerID: any;
  usersList: any;
  defaultUserList = [];
  searchTerm: string = '';
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'userID',
    'firstName',
    'lastName',
    'customerID',
    'country',
    'active',
    'roles',
    'Action',
  ];
  statusFilterList;
  roles;
  isSelected;
  filter_value: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  Roles = ['OPS_USER', 'COUNTRY_IT_ADMIN', 'CUSTOMER_IT_ADMIN', 'GLOBAL_ADMIN'];
  @ViewChild('dialogassignrole')
  dialogassignrole!: TemplateRef<any>;
  selectedRoles: any;
  selecteduser: any;

  property_type = [
    { type: 'All', value: 'All' },
    { type: 'Active', value: 'true' },
    { type: 'Inactive', value: 'false' },
    { type: 'Locked', value: 'Locked' },
  ];

  search_field = [
    { type: 'USER ID', value: 'userID' },
    { type: 'Customer ID', value: 'customerID' },
  ];
  selected_roletype = this.property_type[0].value;
  selected_search_field = this.search_field[0].value;
  search_value: string = '';

  @Output() selectedTabChange: EventEmitter<MatTabChangeEvent>;
  value: number = 0;
  constructor(
    private usermngmt: UserManagementService,
    private dialog: MatDialog,
    private errorDialogService: ErrorDialogService,
    private authService: AuthService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.customerID = sessionStorage.getItem('bbx-customerID');
    this.getUsersList();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  selectRole(event) {
    this.isSelected = true;
    this.selectedRoles = event.value;
  }

  filterBySearch(searchTerm) {
    if (searchTerm && searchTerm.trim() !== '') {
      this.filter_value = searchTerm;
      this.dataSource.data = this.statusFilterList.filter(
        item =>
          item?.userID?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
          item?.customerID?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
          item?.firstName?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
          item?.lastName?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
          item?.country?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    } else {
      this.dataSource.filter = '';
      this.dataSource.data = this.statusFilterList;
    }
  }

  applyFilter() {
    const filterValue = this.search_value.trim().toLowerCase();
    const filterDataArray = this.statusFilterList.filter(user =>
      user[this.selected_search_field].toLowerCase().includes(filterValue)
    );
    this.dataSource.data = filterDataArray;
    this.dataSource.sort = this.sort;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onStatusChange(status) {
    this.searchTerm = '';
    if (status == 'true') {
      this.statusFilterList = this.usersList.filter(
        item => item.active == true && item.locked_temp !== true
      );
    } else if (status == 'false') {
      this.statusFilterList = this.usersList.filter(item => item.active == false);
    } else if (status == 'Locked') {
      this.statusFilterList = this.usersList.filter(item => item.locked_temp == true);
    } else {
      this.statusFilterList = this.usersList;
    }
    this.dataSource.data = this.statusFilterList;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onSearchFieldChange(search_field) {
    this.selected_search_field = search_field;
    this.search_value = '';
    this.applyFilter();
  }

  getUsersList() {
    this.usermngmt.usersList(this.customerID).subscribe(res => {
      this.usersList = res;
      this.statusFilterList = res;
      if (this.search_value) {
        this.dataSource.data = this.statusFilterList.filter(user =>
          user[this.selected_search_field]
            .toLowerCase()
            .includes(this.search_value.trim().toLowerCase())
        );
      } else {
        if (this.filter_value) {
          this.filterBySearch(this.filter_value);
        } else {
          this.dataSource.data = this.defaultUserList = this.usersList;
        }
      }
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  openDialogActivate(userid) {
    const dailogData = {
      message: 'alert.activateUserId',
    };
    const alertDialog = this.dialog.open(AlertComponent, {
      data: dailogData,
    });
    alertDialog.afterClosed().subscribe(res => {
      if (res == 'true') {
        this.toActivateUser(userid);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  toActivateUser(userId, status = true, action = 'activated') {
    this.usermngmt.activateUser(userId, status).subscribe(() => {
      this.errorDialogService.openDialog('alert.userIdSuccess', false, action);
      this.getUsersList();
    });
  }

  openDialogAction(userid, customerID, action) {
    const dailogData = {
      message: 'alert.actionUserId',
      value: action,
    };

    const alertDialog = this.dialog.open(AlertComponent, {
      data: dailogData,
    });
    alertDialog.afterClosed().subscribe(res => {
      if (res === 'true') {
        if (action === 'UnLock') {
          this.unlockUser(userid, customerID, action);
        } else if (action === 'Delete') {
          this.deleteUser(userid, customerID, action);
        } else if (action === 'Inactivate') {
          this.toActivateUser(userid, false, 'Inactivated');
        }
      } else {
        this.dialog.closeAll();
      }
    });
  }

  unlockUser(userid, customerID, action) {
    this.usermngmt.unLockUser(userid, customerID).subscribe(() => {
      this.errorDialogService.openDialog('alert.userIdActionSuccess', false, action);
      this.getUsersList();
    });
  }

  deleteUser(userid, customerID, action) {
    this.usermngmt.deleteUser(userid, customerID).subscribe(() => {
      this.errorDialogService.openDialog('alert.userIdActionSuccess', false, action);

      this.getUsersList();
    });
  }

  assignRole() {
    this.dialog.closeAll();
    const data = {
      userID: this.selecteduser,
      roles: this.selectedRoles,
    };

    this.usermngmt.assignRole(data).subscribe(
      () => {
        this.errorDialogService.openDialog('alert.userRoleSuccess', false);
        this.getUsersList();
      }
      // error => {
      //   this.errorDialogService.openDialog(error.error, true);
      // }
    );
    this.isSelected = false;
  }

  openrolesDialog(element) {
    const userid = element.userID;
    this.selecteduser = userid;
    this.roles = element.roles;

    const myrole = this.authService.getUserRole();
    if (myrole === 'GLOBAL_ADMIN') {
      this.Roles = ['OPS_USER', 'COUNTRY_IT_ADMIN', 'CUSTOMER_IT_ADMIN', 'GLOBAL_ADMIN'];
    } else if (myrole === 'COUNTRY_IT_ADMIN') {
      this.Roles = ['OPS_USER', 'COUNTRY_IT_ADMIN', 'CUSTOMER_IT_ADMIN'];
    } else if (myrole === 'CUSTOMER_IT_ADMIN') {
      this.Roles = ['OPS_USER', 'CUSTOMER_IT_ADMIN'];
    }

    this.dialog.open(this.dialogassignrole, { data: '' });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  isUserCanActivated(user) {
    const myrole = this.authService.getUserRole();
    const myCountry = this.authService.getUserCountry();
    const myCustomerId = this.authService.getUserCustomerID();
    if (myrole === 'GLOBAL_ADMIN') {
      return true;
    } else if (
      myrole === 'COUNTRY_IT_ADMIN' &&
      myCountry === user.country &&
      user.roles.find(element => element == 'GLOBAL_ADMIN') !== 'GLOBAL_ADMIN'
    ) {
      return true;
    } else if (
      myrole === 'CUSTOMER_IT_ADMIN' &&
      myCustomerId === user.customerID &&
      user.roles.find(element => element === 'COUNTRY_IT_ADMIN') !== 'COUNTRY_IT_ADMIN' &&
      user.roles.find(element => element === 'GLOBAL_ADMIN') !== 'GLOBAL_ADMIN'
    ) {
      return true;
    } else {
      return false;
    }
  }

  isUserCanDeleted(user) {
    const myrole = this.authService.getUserRole();
    const myCountry = this.authService.getUserCountry();
    const myCustomerId = this.authService.getUserCustomerID();
    if (myrole === 'GLOBAL_ADMIN') {
      return true;
    } else if (
      myrole === 'COUNTRY_IT_ADMIN' &&
      myCountry === user.country &&
      user.roles.find(element => element == 'GLOBAL_ADMIN') !== 'GLOBAL_ADMIN'
    ) {
      return true;
    } else if (
      myrole === 'CUSTOMER_IT_ADMIN' &&
      myCustomerId === user.customerID &&
      user.roles.find(element => element === 'COUNTRY_IT_ADMIN') !== 'COUNTRY_IT_ADMIN' &&
      user.roles.find(element => element === 'GLOBAL_ADMIN') !== 'GLOBAL_ADMIN'
    ) {
      return true;
    } else {
      return false;
    }
  }

  isUserCanUnlocked(user) {
    const myrole = this.authService.getUserRole();
    const myCountry = this.authService.getUserCountry();
    const myCustomerId = this.authService.getUserCustomerID();
    if (myrole === 'GLOBAL_ADMIN') {
      return true;
    } else if (
      myrole === 'COUNTRY_IT_ADMIN' &&
      myCountry === user.country &&
      user.roles.find(element => element == 'GLOBAL_ADMIN') !== 'GLOBAL_ADMIN'
    ) {
      return true;
    } else if (
      myrole === 'CUSTOMER_IT_ADMIN' &&
      myCustomerId === user.customerID &&
      user.roles.find(element => element === 'COUNTRY_IT_ADMIN') !== 'COUNTRY_IT_ADMIN' &&
      user.roles.find(element => element === 'GLOBAL_ADMIN') !== 'GLOBAL_ADMIN'
    ) {
      return true;
    } else {
      return false;
    }
  }

  isUserCanInActivated(user) {
    const myrole = this.authService.getUserRole();
    const myCountry = this.authService.getUserCountry();
    const myCustomerId = this.authService.getUserCustomerID();
    if (myrole === 'GLOBAL_ADMIN') {
      return true;
    } else if (
      myrole === 'COUNTRY_IT_ADMIN' &&
      myCountry === user.country &&
      user.roles.find(element => element == 'GLOBAL_ADMIN') !== 'GLOBAL_ADMIN'
    ) {
      return true;
    } else if (
      myrole === 'CUSTOMER_IT_ADMIN' &&
      myCustomerId === user.customerID &&
      user.roles.find(element => element === 'COUNTRY_IT_ADMIN') !== 'COUNTRY_IT_ADMIN' &&
      user.roles.find(element => element === 'GLOBAL_ADMIN') !== 'GLOBAL_ADMIN'
    ) {
      return true;
    } else {
      return false;
    }
  }
  openRegisterDailog() {
    this.dialog.open(SignUpComponent, {
      data: {
        message: this.translate.instant('alert.deleteSure'),
        buttonText: {
          ok: this.translate.instant('global.save'),
          cancel: this.translate.instant('global.no'),
        },
      },
    });
  }

  isUserCanRegister() {
    const myrole = this.authService.getUserRole();
    return (
      myrole === 'COUNTRY_IT_ADMIN' || myrole === 'GLOBAL_ADMIN' || myrole === 'CUSTOMER_IT_ADMIN'
    );
  }
}
